import { Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

import { MessageRow } from './MessageRow.tsx';

const textStyle = style({
	font: 'body',
	color: 'gray-600',
	fontSize: 'body-sm',
});

export const SystemMessage = ({ content }: { content: string }) => (
	<MessageRow className="justify-center">
		<Text styles={textStyle}>{content}</Text>
	</MessageRow>
);
